import { Package, Clock } from 'lucide-react';
import { format, parseISO } from 'date-fns';
import { AgencyCourierVisit } from '../../../../core/graphql/types';

interface CourierChargesSectionProps {
  agencyCourierVisits: AgencyCourierVisit[];
}

const CourierChargesSection = ({
  agencyCourierVisits,
}: CourierChargesSectionProps) => {
  return (
    <div className="space-y-4">
      <div className="mb-4 flex items-center gap-2">
        <Package className="h-5 w-5 text-green dark:text-bright-green" />
        <h3 className="text-lg font-semibold">Courier Charges</h3>
      </div>
      <div className="space-y-3">
        {agencyCourierVisits.length > 0 ? (
          agencyCourierVisits.map((agencyCourierVisit, index) => (
            <div
              key={index}
              className="dark:dark-mode-green flex items-start gap-3 rounded-sm border border-green bg-light-mode-green p-3 dark:border-green dark:bg-dark-mode-green"
            >
              <div className="flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-green text-sm font-bold text-white dark:bg-bright-green">
                {agencyCourierVisit.visitSessionNumber}
              </div>
              <div className="flex-1">
                <div className="mb-1 flex items-center gap-2 text-sm text-design-gray dark:text-gray">
                  <Clock className="h-4 w-4" />
                  <span>
                    {`${format(
                      parseISO(agencyCourierVisit.visitStartTime),
                      'HH:mm',
                    )} - ${format(
                      parseISO(agencyCourierVisit.visitEndTime),
                      'HH:mm',
                    )}`}
                  </span>
                </div>
                <div className="flex gap-2">
                  <div className="flex items-center gap-2 text-sm font-medium text-design-black-accent dark:text-gray">
                    <Package className="h-4 w-4 text-green dark:text-bright-green" />
                    <span>
                      {agencyCourierVisit.visitPickupCharges} parcels loaded
                    </span>
                  </div>
                  <div className="flex items-center gap-2 text-sm font-medium text-design-black-accent dark:text-gray">
                    <Package className="h-4 w-4 text-yellow" />
                    <span>
                      {agencyCourierVisit.parcelsStillInAgency ?? 0} parcels
                      left in agency
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="flex items-center justify-center p-4">
            No courier charges
          </div>
        )}
      </div>
    </div>
  );
};

export default CourierChargesSection;
